<template>
  <b-embed
    class="youtube"
    :src="'https://www.youtube.com/embed/' + video + '?rel=0'"
    allowfullscreen
    aspect="16by9"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  ></b-embed>
</template>

<script>
export default {
  name: 'ProgramVideo',
  props: {
    video: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.youtube {
  max-width: 956px;
  max-height: 496px;
}
</style>
